import React from "react";
import { Agency, TrainingCenterBundleDueDateId } from "../../../messages";
import { TrainingCenterCaregiverBundle } from "../../../system/AppState/AppStateTrainingCenter";
import { List } from "../../../utils/List";
import TrainingCenterAgencyHeader from "../../TrainingCenter/TrainingCenterAgencyHeader";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import TrainingCenterBundleCard from "./TrainingCenterBundleCard";

interface Props {
  agency: Agency;
  bundles: List<TrainingCenterCaregiverBundle>;
  languagePreference: TrainingCenterLanguagePreference;
  onClickBundle: (bundleDueDateId: TrainingCenterBundleDueDateId) => void;
}

const TrainingCenterAgencyBundles = (props: Props) => {
  return (
    <div className="TrainingCenterAgencyBundles">
      <TrainingCenterAgencyHeader agency={props.agency} />
      <div className="bundles-list">
        {props.bundles.map((bundle) => (
          <TrainingCenterBundleCard
            key={`due-date-id-${bundle.bundleDueDateId}`}
            bundle={bundle}
            languagePreference={props.languagePreference}
            onClick={props.onClickBundle}
          />
        ))}
      </div>
    </div>
  );
};

export default TrainingCenterAgencyBundles;
